import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import useIsMobile from 'hooks/useIsMobile';
import logoMain from 'assets/logo_main.png';

function BootScreen({ onDone }) {
  const isMobile = useIsMobile(786);

  useEffect(() => {
    if (sessionStorage.getItem('binco_booted')) {
      onDone();
      return;
    }

    if (isMobile) {
      const timer = setTimeout(() => {
        sessionStorage.setItem('binco_booted', '1');
        onDone();
      }, 3000);
      return () => clearTimeout(timer);
    } else {
      // Desktop: skip straight through
      sessionStorage.setItem('binco_booted', '1');
      onDone();
    }
  }, [isMobile, onDone]);

  if (sessionStorage.getItem('binco_booted')) return null;
  if (!isMobile) return null;

  return (
    <MobileLoader>
      <div className="ml-content">
        <img className="ml-logo" src={logoMain} alt="binco" />
        <div className="ml-text">binco is best experienced on desktop</div>
        <div className="ml-bar">
          <div className="ml-bar__fill" />
        </div>
      </div>
    </MobileLoader>
  );
}

const mobileBarFill = keyframes`
  0% { width: 0%; }
  100% { width: 100%; }
`;

const mobileFadeOut = keyframes`
  0%, 80% { opacity: 1; }
  100% { opacity: 0; }
`;

const MobileLoader = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #0a0a0a;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  animation: ${mobileFadeOut} 3s forwards;

  .ml-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .ml-logo {
    height: 50px;
    width: auto;
    opacity: 0.9;
  }
  .ml-text {
    color: #666;
    font-family: Tahoma, sans-serif;
    font-size: 12px;
    letter-spacing: 1px;
    text-align: center;
  }
  .ml-bar {
    width: 180px;
    height: 3px;
    background: #222;
    border-radius: 2px;
    overflow: hidden;
  }
  .ml-bar__fill {
    height: 100%;
    background: #f5a623;
    animation: ${mobileBarFill} 2.5s ease-out forwards;
  }
`;

export default BootScreen;
